const bootResponsiveTables = function () {
    const mq = window.matchMedia("(max-width: 992px)");

    if (!mq.matches) {
        return
    }

    const tables = document.querySelectorAll('.content-wrap table');

    if (!tables.length) {
        return
    }

    tables.forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('responsive-table');

        table.parentNode.insertBefore(wrapper, table);

        wrapper.appendChild(table);
    });
}

bootResponsiveTables();